export default "__VITE_ASSET__CgNTNV9v__"